import IMask from 'imask';

/** Numer krajowy bez kierunkowego — zawsze 9 cyfr (PL i pozostałe kraje z pickerem). */
export const BOOKING_PHONE_MASK = '000 000 000';
export const BOOKING_PHONE_DIGITS = 9;

const normalizeNationalDigits = (raw) => {
  let digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '';

  // Wklejony numer z +48 / 0048 / 48…
  if (digits.startsWith('0048') && digits.length > 4) digits = digits.slice(4);
  else if (digits.startsWith('48') && digits.length > 9) digits = digits.slice(2);

  digits = digits.replace(/^0+/, '') || digits;
  return digits.slice(0, BOOKING_PHONE_DIGITS);
};

export const createBookingPhoneMask = (input) => {
  if (!input) return null;
  if (input._bookingPhoneMask) return input._bookingPhoneMask;

  const mask = IMask(input, {
    mask: BOOKING_PHONE_MASK,
    lazy: true,
  });

  input._bookingPhoneMask = mask;
  input.setAttribute('inputmode', 'numeric');
  input.setAttribute('maxlength', String(BOOKING_PHONE_MASK.length));
  input.setAttribute('pattern', '[0-9]{3}\\s?[0-9]{3}\\s?[0-9]{3}');
  input.setAttribute('title', 'Podaj 9-cyfrowy numer telefonu (bez kierunkowego)');
  if (!input.placeholder) input.placeholder = '123 456 789';

  const applyDigits = (raw) => {
    const digits = normalizeNationalDigits(raw);
    mask.unmaskedValue = digits;
    mask.updateValue();
  };

  input.addEventListener('paste', (event) => {
    const text = event.clipboardData?.getData('text');
    if (!text) return;
    event.preventDefault();
    applyDigits(text);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  // Po hydracji z draftu / syncu wartości bez maski.
  input.addEventListener('booking-phone:refresh', () => {
    applyDigits(input.value);
  });

  return mask;
};

export const destroyBookingPhoneMask = (maskOrInput) => {
  const mask = maskOrInput?._bookingPhoneMask || maskOrInput;
  mask?.destroy?.();
  if (maskOrInput?._bookingPhoneMask) delete maskOrInput._bookingPhoneMask;
};

export const bookingPhoneUnmasked = (input) => {
  const mask = input?._bookingPhoneMask;
  if (mask) return String(mask.unmaskedValue || '').replace(/\D/g, '');
  return normalizeNationalDigits(input?.value);
};

export const isCompleteBookingPhone = (input) => (
  bookingPhoneUnmasked(input).length === BOOKING_PHONE_DIGITS
);
